<!--&lt;!&ndash; <app-header></app-header> &ndash;&gt;-->
<!--<header>-->
<!--  <div class="container-small">-->
<!--    <div class="header">-->
<!--      <div class="header__logo">-->
<!--        <img src="assets/images/removia-logo-white.svg" alt="logo" />-->
<!--      </div>-->
<!--      <div class="header__btn">-->
<!--        <a href="/pricing" class="desktop button default"> Get protected </a>-->
<!--        <a href="#plan" id="scroll-down-mobile" class="mobile button default">-->
<!--          Plan-->
<!--        </a>-->
<!--        <a href="/dashboard" target="_blank" class="button grad"> Log in </a>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</header>-->
<app-landing-header></app-landing-header>

<br />

<main class="main-content">
  <div class="crm mb-25">
    <div class="container-fluid">
      <div class="row">
        <div class="container">
          <br />
          <div class="row">
            <br />
            <div class="col-lg-12">
              <div class="breadcrumb-main">
                <h4
                  class="text-capitalize breadcrumb-title"
                  style="margin-top: 70px"
                >
                  <!-- Blog -->
                  {{ "blog.title" | translate }}
                </h4>
              </div>
            </div>
            <div class="row">
              <a
                *ngFor="let blog of blogs"
                href="/blog/info/{{ blog.post_url }}"
                class="col-xl-6 col-md-6 mb-25"
              >
                <div class="blog-card">
                  <div class="blog-card__thumbnail">
                    <a href="javascript:void(0)">
                      <img
                        [src]="blog.url_img"
                        (error)="handleImageError(blog)"
                        alt=""
                      />
                    </a>
                  </div>
                  <div class="blog-card__details">
                    <div class="blog-card__content">
                      <h4 class="blog-card__title">
                        <span
                          *ngIf="translate.currentLang === 'en'"
                          class="entry-title"
                          rel="bookmark"
                          >{{ blog.title }}</span
                        >
                        <span
                          *ngIf="translate.currentLang === 'de'"
                          class="entry-title"
                          rel="bookmark"
                          >{{ blog.de_title }}</span
                        >
                        <span
                          *ngIf="translate.currentLang === 'ja'"
                          class="entry-title"
                          rel="bookmark"
                          >{{ blog.ja_title }}</span
                        >
                        <span
                          *ngIf="translate.currentLang === 'es'"
                          class="entry-title"
                          rel="bookmark"
                          >{{ blog.es_title }}</span
                        >
                        <span
                          *ngIf="translate.currentLang === 'fr'"
                          class="entry-title"
                          rel="bookmark"
                          >{{ blog.fr_title }}</span
                        >
                      </h4>
                      <p *ngIf="translate.currentLang === 'en'">
                        {{ blog.description }}
                      </p>
                      <p *ngIf="translate.currentLang === 'de'">
                        {{ blog.de_description }}
                      </p>
                      <p *ngIf="translate.currentLang === 'ja'">
                        {{ blog.ja_description }}
                      </p>
                      <p *ngIf="translate.currentLang === 'es'">
                        {{ blog.es_description }}
                      </p>
                      <p *ngIf="translate.currentLang === 'fr'">
                        {{ blog.fr_description }}
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div
            *ngIf="totalPages > 0"
            class="d-flex justify-content-center mb-25 border-top"
          >
            <nav class="dm-page">
              <ul class="dm-pagination d-flex">
                <li class="dm-pagination__item">
                  <a
                    href="javascript:void(0)"
                    (click)="previousPage($event)"
                    [class.disabled]="currentPage === 1"
                    class="dm-pagination__link pagination-control"
                    ><span class="la la-angle-left">&lt;</span></a
                  >
                  <a href="javascript:void(0)" class="dm-pagination__link"
                    ><span class="page-number"
                      >{{ "blog.page" | translate }} {{ currentPage }}
                      {{ "blog.of" | translate }} {{ totalPages }}</span
                    ></a
                  >
                  <a
                    href="javascript:void(0)"
                    (click)="nextPage($event)"
                    [class.disabled]="currentPage === totalPages"
                    class="dm-pagination__link pagination-control"
                    ><span class="la la-angle-right">&gt;</span></a
                  >
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<app-landing-footer></app-landing-footer>
